import { useState, useCallback, useEffect } from 'react'
import queryString from 'query-string'
import { useNavigate, useLocation } from 'react-router'

import { usePhotographers, usePendingPhotographersCount } from '../stores'
import { QUERYSTRING_PARSE_FORMAT } from '../lib/const'

import Loading from '../components/common/Loading'
import ErrorMessage from '../components/common/ErrorMessage'
import PhotographersDatabaseSearchBar from '../components/PhotographersDatabase/PhotographersDatabaseSearchBar'
import PhotographersDatabaseTab from '../components/PhotographersDatabase/PhotographersDatabaseTab'
import PhotographersDatabaseTableHeader from '../components/PhotographersDatabase/PhotographersDatabaseTableHeader'
import PhotographersDatabaseTable from '../components/PhotographersDatabase/PhotographersDatabaseTable'
import PhotographersPagination from '../components/PhotographersDatabase/PhotographersPagination'

const PhotographersDatabasePage = () => {
  const [term, setTerm] = useState(null)
  const [page, setPage] = useState(1)
  const [currentTabIndex, setCurrentTabIndex] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()
  const status = ['approved', 'pending', 'declined'][currentTabIndex]

  useEffect(() => {
    const queryParams = queryString.parse(location.search, QUERYSTRING_PARSE_FORMAT)

    setTerm(queryParams.term)
  }, [])

  useEffect(() => {
    const search = queryString.stringify({ term }, QUERYSTRING_PARSE_FORMAT)

    navigate({ pathname: location.pathname, search }, { replace: true })
  }, [term])

  const { photographers, error, loading, fetchPhotographers } = usePhotographers()
  const { pendingCount, declinedCount, fetchCounts } = usePendingPhotographersCount()

  useEffect(() => {
    fetchPhotographers({ status, page, perPage: 100, term })
  }, [fetchPhotographers, page, status, term])

  useEffect(() => {
    fetchCounts()
  }, [fetchCounts])
  const users = photographers?.data?.filter(({ attributes }) => {
    if (!term) return true
    if (status === 'approved') return attributes.userApproved
    if (status === 'declined') return attributes.userDeclined

    return !attributes.userApproved && !attributes.userDeclined
  })
  const displayedPendingCount = term
    ? photographers?.data?.filter(
      ({ attributes }) => !attributes.userApproved && !attributes.userDeclined,
    ).length || 0
    : pendingCount
  const displayedDeclinedCount = term
    ? photographers?.data?.filter(({ attributes }) => attributes.userDeclined).length || 0
    : declinedCount

  const pagination = photographers?.meta?.pagination || photographers?.meta || {}
  const totalPages = pagination.totalPages || pagination.pages

  const handleTabChange = useCallback(
    (index) => {
      setCurrentTabIndex(index)
      setPage(1)
    },
    [],
  )

  const handleOnSearchChange = useCallback((_term) => {
    setTerm(_term)
    setPage(1)
  }, [])

  if (error) {
    return <ErrorMessage errors={error} />
  }

  return (
    <div className="admin-photographers-container">
      {/* <div className="admin-photographer-subcontainer big-screen"> */}
        <div data-duration-in="300" data-duration-out="100" className="tabs w-tabs">
          <div className="tabs-menu-2 w-tab-menu" role="tablist">
            <PhotographersDatabaseTab
              onClick={() => handleTabChange(0)}
              isActive={currentTabIndex === 0}
            >
              <div>Photographers Database</div>
            </PhotographersDatabaseTab>
            <PhotographersDatabaseTab
              onClick={() => handleTabChange(1)}
              isActive={currentTabIndex === 1}
            >
              <div>Pending to be approved</div>
              {displayedPendingCount > 0 && (
                <div className="div-block-130">
                  <div>{displayedPendingCount}</div>
                </div>
              )}
            </PhotographersDatabaseTab>
            <PhotographersDatabaseTab
              onClick={() => handleTabChange(2)}
              isActive={currentTabIndex === 2}
            >
              <div>Declined Accounts</div>
              {displayedDeclinedCount > 0 && (
                <div className="div-block-130">
                  <div>{displayedDeclinedCount}</div>
                </div>
              )}
            </PhotographersDatabaseTab>
          </div>
          {/* <div className="tabs-content w-tab-content"> */}
            <div
              className="w-tab-pane w--tab-active"
              id={`w-tabs-0-data-w-pane-${currentTabIndex}`}
              role="tabpanel"
            >
              <div className="block-admin-photographer-table">
                <div className="sub-block-admin-photographer">
                  <PhotographersDatabaseTableHeader />
                  {loading ? (
                    <div className="photographers-table-loading">
                      <Loading message="Loading photographers" />
                    </div>
                  ) : (
                    <PhotographersDatabaseTable users={users} searchTerm={term} />
                  )}
                </div>
              </div>
              {!loading && !term && (
                <PhotographersPagination
                  currentPage={page}
                  totalPages={totalPages}
                  onPageChange={setPage}
                />
              )}
            {/* </div> */}
            </div>
          </div>
        <PhotographersDatabaseSearchBar onChange={handleOnSearchChange} term={term} />
      </div>
    // </div>
  )
}

export default PhotographersDatabasePage
